// extracted by css-extract-rspack-plugin
export default {"card":"RmpWWZr_SR8ETMdu","header":"nzuvJUMD_WMQU89C","headerContent":"HXPB__2a1MEzGEWU","body":"Fgf4iNBJC3QGf4it"};